module.exports = __webpack_public_path__ + "media/images/icons/SVG/017-ce0c55736043bbd6f72e9855d74ec362.svg";